<template>
  <div>
    <b-notification :closable="false" :has-icon="true" :icon="icon">
      <div
        class="notification-title"
        style="min-height: 46px; line-height: 46px"
      >
        <slot name="title" />
      </div>
      <slot></slot>
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'MyNotification',
  props: {
    icon: {
      default: function () {
        return ''
      }
    },
    padding: {
      default: function () {
        return true
      }
    },
    type: {
      default: function () {
        return 'info'
      }
    }
  }
}
</script>

<style lang="css">
.notification-title {
  color: #333 !important;
  font-weight: bold !important;
  font-size: 1.1em !important;
}
</style>
